import { BuildBootstrapFunctionReturn } from "@lookiero/messaging-react";
import { IsCategoriesOfferingEnabledView } from "../../projection/offering/viewIsCategoriesOfferingEnabled";
import { IsCompleteYourLookOfferingEnabledView } from "../../projection/offering/viewIsCompleteYourLookOfferingEnabled";
import { IsSalesOfferingEnabledView } from "../../projection/offering/viewIsSalesOfferingEnabled";
import { IsTrendingForYouOfferingEnabledView } from "../../projection/offering/viewIsTrendingForYouOfferingEnabled";
import { baseBootstrap } from "./baseBootstrap";

const isCompleteYourLookOfferingEnabledView: IsCompleteYourLookOfferingEnabledView = async () => true;
const isCategoriesOfferingEnabledView: IsCategoriesOfferingEnabledView = async () => true;
const isSalesOfferingEnabledView: IsSalesOfferingEnabledView = async () => true;
const isTrendingForYouOfferingEnabledView: IsTrendingForYouOfferingEnabledView = async () => true;

const bootstrap: () => BuildBootstrapFunctionReturn = () =>
  baseBootstrap({
    isCompleteYourLookOfferingEnabledView,
    isCategoriesOfferingEnabledView,
    isSalesOfferingEnabledView,
    isTrendingForYouOfferingEnabledView,
  });

export { bootstrap };
